import { type JourneyType } from "@/scalars/journeyType"
import { type InputMethod } from "../types/inputMethod"

export const getDefaultInputMethodFor = (journeyType: JourneyType): InputMethod =>
    journeyType === "COMMISSIONING" ? "meterPoint" : "addressLookup"
